import { render, staticRenderFns } from "./MensagemErro.vue?vue&type=template&id=858fc326&scoped=true&"
import script from "./MensagemErro.vue?vue&type=script&lang=js&"
export * from "./MensagemErro.vue?vue&type=script&lang=js&"
import style0 from "./MensagemErro.vue?vue&type=style&index=0&id=858fc326&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "858fc326",
  null
  
)

export default component.exports